/**
 * Host Global - Contact information for property owner dashboard footer
 * Update these values for production.
 */
export const contactConfig = {
  supportEmail: "support@hostaglobal.com",
  supportPhone: "+966 568885544",
};
